import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaQuoteLeft, FaStar, FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const Testimonials = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const testimonials = [
    {
      id: 1,
      name: "Priya Sharma",
      location: "Mumbai, Maharashtra",
      rating: 5,
      text: "Sanchiti's Fitness Studio has transformed my life completely. The detailed explanation of each asana in both Sanskrit and English helped me understand the deeper meaning of yoga. The instructors are incredibly knowledgeable and patient.",
      practice: "2 years",
      favoriteAsana: "Vrikshasana (Tree Pose)"
    },
    {
      id: 2,
      name: "Rajesh Gupta",
      location: "Delhi, India",
      rating: 5,
      text: "As a beginner, I was nervous about starting yoga, but the welcoming environment and comprehensive guidance made all the difference. The website's detailed asana descriptions helped me practice at home too.",
      practice: "6 months",
      favoriteAsana: "Balasana (Child's Pose)"
    },
    {
      id: 3,
      name: "Anita Desai",
      location: "Bangalore, Karnataka",
      rating: 5,
      text: "The combination of traditional Sanskrit teachings with modern wellness approaches is perfect. I love how each pose is explained with its benefits in both languages. It's helped me connect with my cultural roots.",
      practice: "3 years",
      favoriteAsana: "Padmasana (Lotus Pose)"
    },
    {
      id: 4,
      name: "Dr. Vikram Singh",
      location: "Pune, Maharashtra",
      rating: 5,
      text: "As a healthcare professional, I appreciate the scientific approach to yoga benefits explained here. The studio's focus on proper alignment and breathing techniques has improved my patients' lives too.",
      practice: "4 years",
      favoriteAsana: "Bhujangasana (Cobra Pose)"
    }
  ];

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const current = testimonials[currentTestimonial];

  return (
    <section style={{
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '5rem 0',
      color: 'white'
    }}>
      <div className="container">
        <motion.h2 
          className="section-title"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          style={{ color: 'white', marginBottom: '3rem' }}
        >
          💬 What Our Students Say
        </motion.h2>

        <div style={{
          maxWidth: '800px',
          margin: '0 auto',
          position: 'relative'
        }}>
          <AnimatePresence mode="wait">
            <motion.div
              key={currentTestimonial}
              initial={{ opacity: 0, x: 100 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -100 }}
              transition={{ duration: 0.5 }}
              style={{
                background: 'rgba(255,255,255,0.1)',
                backdropFilter: 'blur(10px)',
                borderRadius: '20px',
                padding: '3rem',
                textAlign: 'center',
                position: 'relative',
                border: '1px solid rgba(255,255,255,0.2)'
              }}
            >
              <FaQuoteLeft style={{
                fontSize: '3rem',
                opacity: 0.3,
                marginBottom: '2rem'
              }} />

              <p style={{
                fontSize: '1.2rem',
                lineHeight: 1.8,
                marginBottom: '2rem',
                fontStyle: 'italic'
              }}>
                "{current.text}"
              </p>

              <div style={{
                display: 'flex',
                justifyContent: 'center',
                gap: '0.5rem',
                marginBottom: '2rem'
              }}>
                {[...Array(current.rating)].map((_, i) => (
                  <FaStar key={i} style={{ color: '#FFD700', fontSize: '1.2rem' }} />
                ))}
              </div>

              <div style={{
                borderTop: '1px solid rgba(255,255,255,0.3)',
                paddingTop: '2rem'
              }}>
                <h4 style={{
                  fontSize: '1.3rem',
                  marginBottom: '0.5rem',
                  color: '#FFD700'
                }}>
                  {current.name}
                </h4>
                <p style={{
                  opacity: 0.8,
                  marginBottom: '1rem'
                }}>
                  📍 {current.location}
                </p>
                <div style={{
                  display: 'flex',
                  justifyContent: 'center',
                  gap: '2rem',
                  flexWrap: 'wrap',
                  fontSize: '0.9rem',
                  opacity: 0.9
                }}>
                  <span>🧘‍♀️ Practicing for: {current.practice}</span>
                  <span>❤️ Favorite: {current.favoriteAsana}</span>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>

          {/* Navigation Buttons */}
          <motion.button
            onClick={prevTestimonial}
            style={{
              position: 'absolute',
              left: '-60px',
              top: '50%',
              transform: 'translateY(-50%)',
              background: 'rgba(255,255,255,0.2)',
              border: 'none',
              borderRadius: '50%',
              width: '50px',
              height: '50px',
              color: 'white',
              fontSize: '1.2rem',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backdropFilter: 'blur(10px)'
            }}
            whileHover={{ scale: 1.1, background: 'rgba(255,255,255,0.3)' }}
            whileTap={{ scale: 0.9 }}
          >
            <FaChevronLeft />
          </motion.button>

          <motion.button
            onClick={nextTestimonial}
            style={{
              position: 'absolute',
              right: '-60px',
              top: '50%',
              transform: 'translateY(-50%)',
              background: 'rgba(255,255,255,0.2)',
              border: 'none',
              borderRadius: '50%',
              width: '50px',
              height: '50px',
              color: 'white',
              fontSize: '1.2rem',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backdropFilter: 'blur(10px)'
            }}
            whileHover={{ scale: 1.1, background: 'rgba(255,255,255,0.3)' }}
            whileTap={{ scale: 0.9 }}
          >
            <FaChevronRight />
          </motion.button>

          {/* Dots Indicator */}
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '1rem',
            marginTop: '2rem'
          }}>
            {testimonials.map((_, index) => (
              <motion.button
                key={index}
                onClick={() => setCurrentTestimonial(index)}
                style={{
                  width: '12px',
                  height: '12px',
                  borderRadius: '50%',
                  border: 'none',
                  background: index === currentTestimonial ? '#FFD700' : 'rgba(255,255,255,0.4)',
                  cursor: 'pointer'
                }}
                whileHover={{ scale: 1.2 }}
                whileTap={{ scale: 0.8 }}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
